import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { getErrorMessage } from './getErrorMessage';

const MySwal = withReactContent(Swal);

export default function useCatchError(isToast = true) {
  const snackbar = useSnackbar();
  const enqueueSnackbar = snackbar?.enqueueSnackbar;

  return useCallback(
    (error) => {
      console.error(error);

      if (isToast && enqueueSnackbar) {
        enqueueSnackbar(getErrorMessage(error), {
          variant: 'error',
        });
      } else if (!isToast) {
        MySwal.fire({
          title: 'Error',
          html: getErrorMessage(error),
          icon: 'error',
        });
      }
    },
    [enqueueSnackbar, isToast],
  );
}
